import { createInstanceNoToken, createInstance } from './config';

const BASE_URL = '/companyConfigs/company';

// eslint-disable-next-line import/prefer-default-export
export const getCompany = async (id) => {
  const axios = createInstanceNoToken();
  const { data } = await axios.get(`${BASE_URL}/${id}/modal`);
  return data;
};

export const getCompanyAndType = async (company, type, token = '') => {
  try {
    const axios = await createInstance({ checkToken: false, token });
    const { data } = await axios.get(`${BASE_URL}/${company}/type/${type}`);
    return { ...data };
  } catch (e) {
    return null;
  }
};

export const getAllCompanyConfigs = async (id) => {
  try {
    const axios = createInstanceNoToken();
    const { data } = await axios.get(`${BASE_URL}/${id}`);
    return data;
  } catch (e) {
    return null;
  }
};
